'use client'

import { Anchor } from '@/components/client/seo/anchor'
import { ImageWrapper } from '@/components/image'

interface RowImageProps {
  image: string | null
  href: string
  eager: boolean
}

// The product photo on the neutral inset frame (multiply blend keeps the
// cutout's white background invisible). Duplicates the name link for pointer
// users only — hidden from the tab order and assistive tech.
export const RowImage = ({ image, href, eager }: RowImageProps) => (
  <Anchor
    href={href}
    tabIndex={-1}
    aria-hidden
    data-tracking="ignore"
    className="bg-navy/5 relative col-start-1 row-[1/3] min-h-[104px] w-full self-stretch overflow-hidden rounded-xl xs:min-h-[112px] md:min-h-[128px] laptop:row-[1/4] laptop:min-h-40"
  >
    {image ? (
      <ImageWrapper
        image={image}
        origin="directory/row"
        loadTime={eager ? 'eager' : 'lazy'}
        sizingProps={{
          sizes:
            '(min-width: 1400px) 192px, (min-width: 1200px) 160px, (min-width: 768px) 128px, (min-width: 370px) 112px, 104px',
          minWidth: 104,
          maxWidth: 576,
          widths: [104, 112, 128, 160, 192, 208, 224, 256, 312, 320, 336, 384, 480, 576],
        }}
        imgProps={{
          alt: '',
          className: 'absolute inset-0 h-full w-full object-contain p-2 mix-blend-multiply md:p-3',
        }}
      />
    ) : null}
  </Anchor>
)
